import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-fire-fill text-primary-500 text-2xl"></i>
              </div>
              <span className="font-heading text-xl text-foreground-50">黑料在线看</span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              汇聚娱乐圈、网红、明星最新独家内幕与爆料资讯。海量内容实时更新，一站式满足你的好奇心。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-500/20 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-foreground-400 text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-500/20 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-foreground-400 text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-500/20 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-foreground-400 text-sm"></i>
              </a>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading text-base text-foreground-50 mb-4">
              <a href="#categories">内容分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-400 hover:text-primary-400 text-sm transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-heading text-base text-foreground-50 mb-4">
              <a href="#links">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors">
                  免责声明
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-base text-foreground-50 mb-4">
              <a href="#contact">联系我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-foreground-400 text-sm">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-xs"></i>
                </div>
                <span>tips@heiliaozx.com</span>
              </li>
              <li className="flex items-center gap-2 text-foreground-400 text-sm">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-customer-service-line text-xs"></i>
                </div>
                <span>24小时在线爆料</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; 2026 黑料在线看 - 独家内幕全收录。本站内容均来自网友投稿，不代表本站立场。
          </p>
          <p className="text-foreground-500 text-xs">
            <a href="#" className="hover:text-foreground-300 transition-colors" rel="nofollow">京ICP备xxxxxxxx号</a>
          </p>
        </div>
      </div>
    </footer>
  );
}